import { Create, SimpleForm, TopToolbar, useNotify, useRedirect } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import { ErasmusServicePath, INTERNSHIP_INCOMING_ERASMUS } from "utils/constants";
import { useNotifyError } from "utils/useNotifyError";
import CreateForm from "./CreateForm";
import { buildInternshipStudentPayload, validateInternshipStudent } from "./utils";

const CreateIncomingIntershipStudent = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const redirect = useRedirect();

  return (
    <Create
      title="Създаване на пристигащ студент на стаж"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          <BackButtonToolbar />
        </TopToolbar>
      }
      transform={buildInternshipStudentPayload}
      mutationOptions={{
        meta: { useFormData: true },
        onSuccess: () => {
          notify("Успешно създаден пристигащ студент на стаж", { type: "success" });
          redirect("list", `${ErasmusServicePath}${INTERNSHIP_INCOMING_ERASMUS}`);
        },
        onError: notifyError,
      }}
    >
      <SimpleForm validate={validateInternshipStudent}>
        <CreateForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateIncomingIntershipStudent;
